import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { analytics, logEvent } from './firebase';
import { getDeviceInfo } from '../utils/device';

export function usePageViewTracking(): void {
  const location = useLocation();

  useEffect(() => {
    if (!analytics || !location?.pathname) return;

    const info = getDeviceInfo();

    logEvent(analytics, 'page_view', {
      page_location: window.location.href,
      page_path: location.pathname,
      device_category: info.device_category, // custom
      os_name: info.os,                      // custom
      os_version: info.os_version,           // custom (optional)
    });
  }, [location]);
}
